import React, { useState } from 'react';
import { ListBase, ListProps } from 'react-admin';
import { useLocation } from 'react-router-dom';
import ChangeInstancesListPage from '../ChangeInstances/List/ChangeInstancesListPage';
import { ChangeInstancesListConfig } from '../ChangeInstances/List/types';
import ChangeInstanceRow from './ChangeInstanceRow';

const config: ChangeInstancesListConfig = {
    resource: 'owner_change_instances',
    serviceItemPath: '/owner_service_items',
    applicationsResource: 'owner_applications',
    serviceItemsResource: 'owner_service_items',
    servicesResource: 'services',
    teamsResource: 'consumer_teams',
    partyField: {
        label: 'Consumer Team',
        team: (record) => record.consumer_team,
        pov: 'consumer',
    },
    // owners approve / reject / complete from the panel, so it must be able to
    // refresh the list once the state changes
    ExpandedRow: ChangeInstanceRow,
    expandedRowNeedsRefresh: true,
};

const ChangeList = (props: ListProps) => {
    // Same raw ?id= pin as the consumer list — see ChangeInstances/ChangeList.
    // Notifications only ever link a consumer to their own rejected changes,
    // but the param is honoured here too so any direct link behaves the same.
    const location = useLocation();
    const [pinnedId] = useState(() => new URLSearchParams(location.search).get('id'));

    return (
        <ListBase
            sort={{ field: 'id', order: 'DESC' }}
            filter={pinnedId ? { light: true, id: pinnedId } : { light: true }}
            perPage={25}
            filterDefaultValues={pinnedId ? undefined : { state: 'PENDING,APPROVED' }}
            {...props}
        >
            <ChangeInstancesListPage config={config} />
        </ListBase>
    );
};

export default ChangeList;
